<template>
  <div class="reset">
    <div class="container">
      <div class="form">
        <div class="title">
          Set Your Password
        </div>
        <div class="subtitle">
          Password must be at least 8 characters
        </div>
        <div class="input-wrap">
          <input
            type="password"
            class="input"
            placeholder="Password"
            v-model="password"
            name="password"
            v-validate="'required|min:8'"
          />
          <span class="validate-error" v-if="errors.has('password')">{{
            errors.first("password")
          }}</span>
        </div>
        <div class="input-wrap">
          <input
            type="password"
            class="input"
            placeholder="Confirm Password"
            v-model="password_confirmation"
            name="confirmPassword"
            v-validate="{ required: true, min: 8, is: password }"
          />
          <span class="validate-error" v-if="errors.has('confirmPassword')">{{
            errors.first("confirmPassword")
          }}</span>
        </div>
        <button
          class="btn"
          @click.prevent="$validator.validateAll()"
          @click="setAdmin"
          :disabled="!isComplete"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RegesterAdmin",
  data() {
    return {
      email: "",
      confirmation_email_code: null,
      password: "",
      password_confirmation: ""
    };
  },
  computed: {
    isComplete() {
      return this.password_confirmation && this.password;
    }
  },
  methods: {
    ...mapActions(["setAdminPassword"]),
    setAdmin() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      this.setAdminPassword(this._data).then(res => {
        this.$router.push("/login");
      });
    }
  },
  mounted() {
    this.email = this.$route.query.email;
    this.confirmation_email_code = this.$route.query.confirmation_email_code;
  }
};
</script>

<style scoped lang="scss">
@import "../styles/colors";
.reset {
  max-width: 100%;
  width: 100vw;
  max-height: 100%;
  height: 100vh;
  display: flex;
  background-color: transparent;
  padding: 100px 0 0 0;
}
.form {
  padding: 36px 80px 40px 80px;
  max-width: 500px;
  max-height: 400px;
  margin: 36px 0 0 auto;
  box-shadow: 0 3px 15px -9px $boxShadow;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
  background-color: $white;
  width: 50%;
  height: 100%;
  position: relative;
}
.title {
  color: $blue;
  font-family: TTNormsBold, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}
.subtitle {
  color: $gray;
  font-family: TTNormsMedium, sans-serif;
  font-size: 16px;
  text-align: center;
  margin: 0 0 36px 0;
  padding: 0 5px;
}
.input.invalid {
  border: 1px solid $red;
}
.input-wrap {
  margin: 0 0 15px 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  font-family: TTNormsMeduim, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMeduim, sans-serif;
}
.input:disabled {
  border: none;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
@media screen and (max-width: 1000px) {
  .form {
    padding: 30px;
    max-width: 450px;
  }
}
@media screen and (max-width: 768px) {
  .reset {
    background: url("../images/bg/sky-mobile.jpg");
  }
  .form {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
